import axios from '@/axios'

export default {
  fetchProductByCollection(){
    return axios.get(`/dashboard/products`)
  },
  fetchCriticalMaterial(params){
    return axios.get(`/dashboard/materials`, {params})
  }
}